module.exports = __webpack_public_path__ + "img/gemClose.77833658.svg";